import { render, staticRenderFns } from "./LocationSelect.vue?vue&type=template&id=35145c0b"
import script from "./LocationSelect.vue?vue&type=script&lang=ts"
export * from "./LocationSelect.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports